import { createContext } from 'react';

export default createContext<{
  isLoggedIn: boolean;
  userId?: string | null;
  token?: string | null;
  login: (uid: string, token: string, refresh_token: string, expirationDate?: Date) => void;
  logout: () => void;
}>({
  isLoggedIn: false,
  userId: null,
  token: null,
  login: () => {},
  logout: () => {},
});
